import styled from 'styled-components';
import { TabContentWrapper } from '../UI/styledConstants';

export const Wrapper = styled(TabContentWrapper)`
.resendOtp{
	font-size: 12px;
	.resendBtn{
		color: green;
		cursor: pointer;
	}
	.timer{
		color: red;
		
	}
}
	.payee-actions {
		button {
			max-width: 78px;
		}
	}
	.filter{
		align-items: center;
		padding: 8px 12px;
		border-radius: 4px;
		margin-bottom: 20px;
		background: transparent linear-gradient(90deg,#00baf2 0%,#002970 100%) 0% 0% no-repeat padding-box;
	 .bold{
		color:#fff;
	 }
		input{
		padding: 4px 10px;
    box-shadow: 0px 1px 2px #00297026;
    border-radius: 5px;
    background-color: #fff;
    font-size: 12px;
    max-width: 142px;
    border: 2px solid transparent;
		  &.mr-20{
			margin-right: 20px;
		  }
	  }
	}
	.beneficiary-list-heading {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;
		h2 {
			margin: 0;
		}
		button {
			max-width: 180px;
		}
		.limit-with-action {
			display: flex;
			align-items: center;
			.limit-available {
				margin-right: 20px;
				font-size: 14px;
				white-space: nowrap;
			}
		}
	}
	.pay-modal-form {
		padding: 20px 0 0 0;
		.form-field {
			margin-bottom: 15px;
		}
	}
	&.send-money-form{
		.tab-content-left{
			align-self: stretch;
			height: auto;
			
		}
	}
	.senderDetails{
		/* border: 1px solid #D6EAF4;
    border-radius: 8px;
    padding: 10px; */
		&>div{
			
			p{
				/* &:first-child{
					font-size: 16px;
					color: #002970;
				} */
				&:last-child{
					font-size: 12px;
					line-height: 15px;
					color: #00BAF2;
				}
			}
		}
	}
	@media only screen and (max-width: 900px) {
		.limit-with-action {
			display: block;
		}
		.beneficiary-list-heading h2 {
			font-size: 16px;
		}
	}
	@media only screen and (max-width: 767px) {
		.limit-with-action {
			display: block;
		}
		.beneficiary-list-heading h2 {
			font-size: 16px;
		}
	}
	@media only screen and (max-width: 500px){
		.filter{
           flex-wrap: wrap;
		  
		   input{
			max-width: 100%;
			width: 100%;
			flex-grow: 1;
		   }
		}
		.limit-with-action{
			.button-outline{
				font-size: 12px;
			}
		}
	}
`;
